import { GuidebookSummaryChecklistContainer } from "containers/GuidebookSummaryContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const description =
    "장례 사후 처리와 행정 처리, 더 이상 헷갈리지 않도록 10년의 노하우를 담아 알려드립니다.";

  return {
    props: {
      pageDescription: description,
      pageOgTitle: "장례 후 절차와 체크리스트 한눈에 보기 - [고이 장례 가이드북]",
      pageOgDescription: description,
      pageKeywords:
        "탈상, 삼우제, 49재, 49제, 사십구재, 사망신고, 자산 이전, 안심상속 원스톱 서비스, 상속 포기, 한정승인, 특별한정승인",
    },
  };
};

interface Page {
  pageOgTitle: string;
}

function GuidebookSummaryChecklist({ pageOgTitle }: Page) {
  return (
    <>
      <GuidebookSummaryChecklistContainer />
    </>
  );
}

export default GuidebookSummaryChecklist;
